import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getCustomers } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import NotificationHistoryTable from "../../components/Tables/NotificationHistoryTable";
import Select from "react-select";

class NotificationSendAndHistory extends React.Component {
  constructor(props) {
    super(props);
    this.qrRef = React.createRef();
    this.state = {
      customer_id: '',
      message: '',
      type: '',
      subject: '',
      customers: [],
      selectedCustomer: [],
      isLoad: true,
      loading: false,
    }
  }
  async componentDidMount() {
    window.scrollTo(0, 0);
    this.setState({ customers: await getCustomers(), isLoad: false });
  }
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  handleCustomerChange = (selectedCustomer) => {
    const formattedSelectedOptions = {
      value: selectedCustomer.value,
      label: selectedCustomer.label,
    };
    this.setState({
      customer_id: formattedSelectedOptions.value,
      selectedCustomer: formattedSelectedOptions
    });
  };
  handleSubmit = async () => {
    this.setState({ loading: true });
    const data = { customer_id: this.state.customer_id, message: this.state.message, type: this.state.type, subject: this.state.subject }
    try {
      const response = await apiCall('business/notifications/send', 'post', data);
      mainHelper.toastMessage(response.status, response.message);
      this.setState({ loading: false });
    } catch (e) {
      this.setState({ loading: false });
    }

  }

  render() {

    const { loading, customers, selectedCustomer } = this.state;
    const { userPermissions } = this.props;
    const userHasViewNotificationHistory = userPermissions.includes('view notification history');
    const userHasSendNotification = userPermissions.includes('send notification');
    const customerFormattedOptions = customers && customers.map(option => ({
      value: option.id,
      label: option.name + ' ' + (option.surname || "")
    }));
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Özel Bildirim Gönder"
              Breadcrumb={[
                { name: "Bildirimler", navigate: "" },
                { name: "Özel Bildirim Gönder", navigate: "" },
              ]}
            />

            <div className="row clearfix justify-content-center">
              <div className="col-lg-12">
                <div className="card">
                  <div className="body text-center">
                    <h6>Özel Bildirim Gönder</h6>
                    <div className="col-lg-12 d-flex justify-content-center">
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <label htmlFor="type" className="font-weight-bold text-cyan">
                            Bildirim Tipi
                          </label>
                          <select name="type" id='type' className="form-control"
                            onChange={this.handleChange}>
                            <option value="">Tip Seçiniz</option>
                            <option value="email">Email</option>
                            <option value="sms">Sms</option>
                          </select>
                        </div>
                        <div className="form-group">
                          <label htmlFor="customer_id" className="font-weight-bold text-cyan">
                            Müşteri
                          </label>
                          <Select
                            id="customer"
                            placeholder="Müşteri Seçiniz..."
                            options={customerFormattedOptions}
                            value={selectedCustomer}
                            onChange={this.handleCustomerChange}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="subject" className="font-weight-bold text-cyan">
                            Konu <small className="text-danger">- Sadece email gönderimi için gereklidir</small>
                          </label>
                          <input type="text" name="subject" id='subject' className="form-control"
                            onChange={this.handleChange} />
                        </div>
                        <div className="form-group">
                          <label htmlFor="message" className="font-weight-bold text-cyan">
                            Mesaj
                          </label>
                          <input type="text" name="message" id='message' className="form-control"
                            onChange={this.handleChange} />
                        </div>
                        {loading ? (
                          <button
                            className="btn btn-outline-primary btn-lg btn-block"
                            disabled={true}
                            style={{ textAlign: "-webkit-center" }}
                          >
                            Lütfen Bekleyin... <ReactLoading type="spin" color="#268bd2" width={'24px'}
                              height={'24px'} />
                          </button>
                        ) : (
                          <button disabled={!userHasSendNotification}
                            onClick={this.handleSubmit}
                            className="btn btn-outline-primary btn-lg btn-block"
                            type="submit"
                          >
                            Gönder
                          </button>
                        )}


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="body">
                    <h6>Gönderilen Bildirim Geçmişi</h6>
                    <div className="col-lg-12">
                      {userHasViewNotificationHistory ?
                        <NotificationHistoryTable></NotificationHistoryTable>
                        : ""}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
      ;
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(NotificationSendAndHistory)));
